import {
    FrontendFilter, FrontendFilterBatchAction,
    FrontendFilterGroup, FrontendFilterInputBooleanSelect,
    FrontendFilterInputSelectOneWithSearch,
    FrontendFilterInputText,
    FrontendFilterOption,
    FrontendFilterResultColumn, FrontendFilterValues
} from "@/components/FrontendFilters/structs";
import store from "@/store";
import {i18n} from "@/main"
import {hasAllPermissions, hasAnyPermission, hasPermission} from "@/helpers/permissions";
import Vue from "vue";
import axios from "axios";

export class FrontendFiltersLocationSearch implements FrontendFilterGroup {
    identifier = 'locations';
    subIdentifier = 'general';

    pageIcon = 'pe-7s-global'
    pageTitleLanguageKey = 'frontend-filters.page-titles.locations';

    resultRowPreprocessor = (resultRow: Record<string,any>) => resultRow;


    searchApiPath = '/api/rest/locations';
    resultsPerPage = 1000;
    searchApiDefaultParameters = {
        only_linked: 1,
        include_properties: [
            'services.ship_from_store.enabled',
            'services.click_and_collect.enabled',
        ],
    };

    getResultLink = (result: Record<string, any>, filterValues: FrontendFilterValues): Record<string, any> => {
        return {
            name: 'locationEditContactInfo',
            params: {
                locationTypeIdentifier: result.location_type.identifier,
                locationIdentifier: result.identifier,
            }
        };
    };

    batchActions = [
        new FrontendFilterBatchAction(
            'batch-service-times',
            () => hasAllPermissions('locations.edit.batch', 'locations.servicetimes.edit'),
            // @ts-ignore
            () => Vue.component('BatchAddOpeningTimes', () => import('../../views/Locations/Modals/BatchAddOpeningTimes.vue') as object),
        ),
        new FrontendFilterBatchAction(
            'batch-generate-labels',
            // @ts-ignore
            () => store.state.config.settings['locations.batchCreateInternalShippingLabels.defaultSenderLocationId'] && hasPermission('locations.batchcreateinternalshippinglabels'),
            // @ts-ignore
            () => Vue.component('BatchGenerateShipmentLabels', () => import('../../views/Locations/Modals/BatchGenerateShipmentLabels.vue') as object),
        ),
        new FrontendFilterBatchAction(
            'batch-publish',
            // @ts-ignore
            () => hasAnyPermission([
                'locations.contactinfo.edit',
                'locations.servicetimes.edit',
                'locations.properties.edit',
                'locations.services.edit',
            ]),
            // @ts-ignore
            (selectedResults: Record<string,any>[]) => {
                return axios.post(`/api/rest/locations-batch/publish`, {
                    location_ids: selectedResults.map((item) => item.id),
                })
                    .then(() => {
                        // @ts-ignore
                        Vue.prototype.$alert("De locaties zijn succesvol gepubliceerd");
                    })
            },
        ),
    ];

    headerComponent = () => Vue.component('FrontendFiltersLocationHeader', () => import('../../views/Locations/components/FrontendFiltersLocationHeader.vue') as object);

    filters = [
        new FrontendFilter(
            'type',
            new FrontendFilterInputSelectOneWithSearch(),
            () => store.getters.getLocationDataTypes
                // @ts-ignore
                .then(() => store.state.locationDataTypes['locationTypes'].map((locationType: Record<string,string>) => new FrontendFilterOption(
                    locationType.identifier,
                    locationType.display_name,
                ))),
        ),
        new FrontendFilter(
            'identifier',
            new FrontendFilterInputText(),
        ),
        new FrontendFilter(
            'display_name_partial',
            new FrontendFilterInputText(),
        ),
        new FrontendFilter(
            'active',
            new FrontendFilterInputBooleanSelect(),
        ),
        new FrontendFilter(
            'ship_from_store',
            new FrontendFilterInputBooleanSelect(),
            undefined,
            undefined,
            (filterValues): FrontendFilterValues => {
                if (filterValues['ship_from_store']) {
                    if (!filterValues.filter_by_property_value) {
                        filterValues.filter_by_property_value = []
                    }

                    filterValues.filter_by_property_value['services.ship_from_store.enabled'] = filterValues['ship_from_store']
                }

                return filterValues;
            },
        ),
        new FrontendFilter(
            'click_and_collect',
            new FrontendFilterInputBooleanSelect(),
            undefined,
            undefined,
            (filterValues): FrontendFilterValues => {
                if (filterValues['click_and_collect']) {
                    if (!filterValues.filter_by_property_value) {
                        filterValues.filter_by_property_value = []
                    }

                    filterValues.filter_by_property_value['services.click_and_collect.enabled'] = filterValues['click_and_collect']
                }

                return filterValues;
            },
        ),
    ];

    columns = [
        new FrontendFilterResultColumn(
            'identifier',
            (resultRow) => resultRow.identifier,
            undefined,
            'identifier',
        ),
        new FrontendFilterResultColumn(
            'type',
            (resultRow) => resultRow.location_type.display_name,
            undefined,
            'type',
        ),
        new FrontendFilterResultColumn(
            'display_name',
            (resultRow) => resultRow.display_name,
            undefined,
            'display_name_partial',
        ),
        new FrontendFilterResultColumn(
            'active',
            (resultRow) => parseInt(resultRow.active)
                ? i18n.t(`omt.gui.general.yes`).toString()
                : i18n.t(`omt.gui.general.no`).toString(),
            undefined,
            'active',
        ),
        new FrontendFilterResultColumn(
            'ship_from_store',
            (resultRow) => resultRow.location_properties['services.ship_from_store.enabled']
                ? i18n.t(`omt.gui.general.yes`).toString()
                : i18n.t(`omt.gui.general.no`).toString(),
            undefined,
            'ship_from_store',
        ),
        new FrontendFilterResultColumn(
            'click_and_collect',
            (resultRow) => resultRow.location_properties['services.click_and_collect.enabled']
                ? i18n.t(`omt.gui.general.yes`).toString()
                : i18n.t(`omt.gui.general.no`).toString(),
            undefined,
            'click_and_collect',
        ),
        new FrontendFilterResultColumn(
            'buttons',
            () => Vue.component('ColumnValueButtons', () => import('@/views/Locations/components/ColumnValueButtons.vue') as object),
        ),
    ];
}
